import { render, staticRenderFns } from "./meal-categories.vue?vue&type=template&id=2ceba088&scoped=true"
import script from "./meal-categories.vue?vue&type=script&lang=js"
export * from "./meal-categories.vue?vue&type=script&lang=js"
import style0 from "./meal-categories.vue?vue&type=style&index=0&id=2ceba088&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ceba088",
  null
  
)

export default component.exports